const getCategory = state => id => state.categories.find(c => c.id === id);

export default {
  getCategory,
};
